import React from 'react'
import QASIcon from '../../icons/QAS'

interface QAItem {
  id: string
  question?: string
  answer?: string
  facilitator_question?: string
  content?: string
  meetingId: string
  meeting_id?: string
  start_time?: number
  end_time?: number
  star?: boolean
}

interface QAsCardsProps {
  qas: QAItem[]
  setQas?: React.Dispatch<React.SetStateAction<QAItem[]>>
  meetings: any[]
  participants: any
  setProject: React.Dispatch<React.SetStateAction<any>>
  project: any
}

const QAsCards = ({ qas }: QAsCardsProps) => {
  const getDisplayQuestion = (qa: QAItem) => {
    return qa.facilitator_question || qa.question || 'Question'
  }

  const getDisplayAnswer = (qa: QAItem) => {
    return qa.content || qa.answer || 'Answer'
  }

  return (
    <div className="container mx-auto px-4 pt-5">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {qas.map((item) => (
          <div
            className="max-w-sm p-6 bg-white rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 relative"
            key={item.id}
          >
            {/* Star indicator */}
            {item.star && (
              <div className="absolute top-2 right-2">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 15L4.122 18.09L5.245 11.545L0.489 6.91L7.061 5.955L10 0L12.939 5.955L19.511 6.91L14.755 11.545L15.878 18.09L10 15Z"
                    fill="#FFC921"
                  />
                </svg>
              </div>
            )}

            <div className="flex justify-center mb-4">
              <QASIcon isSelected={false} />
            </div>

            <h3 className="font-semibold text-base mb-3 text-[#40424A]">{getDisplayQuestion(item)}</h3>
            <p className="text-gray-700 text-sm">{getDisplayAnswer(item)}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default QAsCards
